export interface PendingCheckout {
  operationId: string;
  kind: 'pro_manual' | 'pro_automatic' | 'trial' | 'manual_storage' | 'automatic_storage';
  status: 'creating' | 'pending' | 'confirmation_required';
  checkoutUrl?: string; confirmationUrl?: string; canCancel: boolean; canResume: boolean;
  paymentState?: 'processing' | 'requires_review';
}
export type CheckoutGuardState = { enabled: false } | { enabled: true; pending: PendingCheckout | null; deletionInProgress?: boolean };
export function safeCheckoutRecoveryUrl(value: unknown) {
  if (typeof value !== 'string') return undefined;
  try { const url = new URL(value); if (url.protocol === 'https:' && ['checkout.stripe.com','invoice.stripe.com'].includes(url.hostname) && !url.username && !url.password) return url.href; } catch { /* No untrusted URL. */ }
}
